import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

import '../stylesheets/global.scss';

import logo from '../images/logo.svg';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error, { level: Sentry.Severity.Critical });
    });
  }

  render() {
    if (this.state.error) {
      //render fallback UI
      return (
        <div className="error-display-wrapper">
          <div onClick={() => Sentry.showReportDialog()}>
            <img src={logo} alt="oops" className="oops" />
            <p>We're sorry — something's gone wrong.</p>
            <p>Our team has been notified, but click here fill out a report.</p>
          </div>
        </div>
      );
    } else {
      //when there's not an error, render children untouched
      return this.props.children;
    }
  }
}
